import { useToast } from 'modules/toast/hooks/useToast';
import { extractionSuccess } from 'modules/toast/toastDictionary';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/Button/Button';
import { ExtractionSuccessOnboardingRedirectButton } from 'shared/components/ExtractionSuccessOnboardingRedirectButton';
import { InfoBox } from 'shared/components/InfoBox/InfoBox';
import { ModalContent } from 'shared/components/Modal/ModalContent';
import { useJobOrdersStore } from 'shared/hooks/stores/useJobOrdersStore';
import { useExpertProfileRefresh } from 'shared/hooks/useExpertProfileRefresh';

interface ExtractionSuccessModalProps {
  onClose: () => void;
}

export const ExtractionSuccessModal: FC<ExtractionSuccessModalProps> = ({ onClose }) => {
  const { displayToast } = useToast();
  const { t } = useTranslation();
  const clearJobOrderLists = useJobOrdersStore((state) => state.clearJobOrderLists);
  const { refreshExpertProfile, loading } = useExpertProfileRefresh();

  const handleCancel = useCallback(async () => {
    clearJobOrderLists();
    await refreshExpertProfile();
    displayToast(extractionSuccess(t));
    onClose();
  }, [onClose]);

  return (
    <ModalContent
      name="extractionSuccessModal"
      className="max-w-[707px]"
      title={t('modal:extraction.success.title')}
    >
      <div className="flex w-full flex-col items-center gap-6">
        <p className="max-w-[500px] whitespace-pre-line text-center">
          {t('modal:extraction.success.description')}
        </p>
        <InfoBox className="max-w-[473px]" message={t('modal:extraction.success.info')} />
      </div>
      <div className="mt-8 grid w-full gap-4 md:mt-12 md:grid-cols-2 md:gap-6">
        <Button
          variant="outline"
          color="black"
          name="extractionSuccessCloseButton"
          onClick={handleCancel}
          disabled={loading}
          loading={loading}
        >
          {t('modal:extraction.success.closeAction')}
        </Button>
        <ExtractionSuccessOnboardingRedirectButton
          className="row-start-1 w-full md:row-start-auto"
          label={t('modal:extraction.success.confirmAction')}
          onRedirect={onClose}
        />
      </div>
    </ModalContent>
  );
};
